import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'attach',
  standalone: true,
})
export class AttachPipe implements PipeTransform {
  transform<A extends object, B, K extends string>(
    previousContext: A,
    other: B,
    key: K
  ) {
    return Object.assign({}, previousContext, {
      [key]: other,
    } as Record<K, B>);
  }
}
